<template>
  <v-dialog
    :model-value="modelValue"
    max-width="420"
    @update:model-value="setDialogOpen"
  >
    <v-card
      class="dialog-card dialog"
      rounded="xl"
    >
      <header class="dialog__header">
        <h3 class="dialog-title">QR kod uzvanika</h3>

        <v-btn
          aria-label="Zatvori QR kod"
          class="button button--icon dialog-close"
          icon="mdi-close"
          size="x-small"
          variant="text"
          @click="setDialogOpen(false)"
        />
      </header>

      <div class="dialog__content">
        <img
          v-if="qrCodeImageUrl"
          class="dialog__image-box"
          :src="qrCodeImageUrl"
          :alt="`QR kod za ${inviteeName}`"
        />
        <p
          v-else
          class="dialog__image-box"
          role="alert"
        >
          QR kod uzvanika nije bilo moguće učitati.
        </p>

        <strong class="dialog__invitee">{{ inviteeName }}</strong>
        <span class="dialog__event">{{ eventName }}</span>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup>
defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },

  qrCodeImageUrl: {
    type: String,
    default: '',
  },

  inviteeName: {
    type: String,
    required: true,
  },

  eventName: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue'])

function setDialogOpen (isOpen) {
  emit('update:modelValue', isOpen)
}
</script>

<style
  scoped
  lang="scss"
>
.dialog {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding:
      clamp-bp("sm", "xl", 16, 20)
      clamp-bp("sm", "xl", 16, 24);
  }

  &__content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding:
      clamp-bp("sm", "xl", 24, 28)
      clamp-bp("sm", "xl", 16, 24)
      clamp-bp("sm", "xl", 28, 32);
    text-align: center;
  }

  &__image-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 200px;
    margin: 0;
    color: var(--color-text-muted);
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    object-fit: contain;
  }

  &__invitee {
    margin-top: 18px;
    color: var(--color-black);
    font-size: 15px;
    font-weight: 600;
    line-height: 22px;
  }

  &__event {
    margin-top: 4px;
    color: var(--color-text-muted);
    font-size: 12px;
    font-weight: 300;
    line-height: 18px;
  }
}
</style>
